import { render, staticRenderFns } from "./ClinicalQuestionnaireForm.vue?vue&type=template&id=3991d9c2"
import script from "./ClinicalQuestionnaireForm.vue?vue&type=script&lang=js"
export * from "./ClinicalQuestionnaireForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports